export default "__VITE_ASSET__CyMNuwWV__"